'use client';

import { Box, List } from '@wishket/design-system';
import { useState } from 'react';

import { CareerItem } from '@/shared/types';
import {
  PersonalizedAreaSelectButton,
  ResponsiveListShell,
} from '@/features/Landing';
import { CAREER } from '@/features/Profile';

interface PersonalizedAreaCareerSelectProps {
  selectedCareer: CareerItem;
  handleCareerChange: (item: CareerItem) => void;
}

const MIN_CAREER_KEY = 1;
const MAX_CAREER_KEY = 20;

const PersonalizedAreaCareerSelect = ({
  selectedCareer,
  handleCareerChange,
}: PersonalizedAreaCareerSelectProps) => {
  const [isCareerSelectOpen, setIsCareerSelectOpen] = useState(false);

  const getCareerText = () => {
    const careerKey = Number(selectedCareer.key);

    if (careerKey <= MIN_CAREER_KEY) return '1년 이하';
    if (careerKey >= MAX_CAREER_KEY) return '20년 이상';

    return `${selectedCareer.value}차`;
  };

  const onSelectClick = () => setIsCareerSelectOpen((prev) => !prev);

  const closeSelect = () => setIsCareerSelectOpen(false);

  return (
    <Box className="relative">
      <PersonalizedAreaSelectButton
        text={getCareerText()}
        onClick={onSelectClick}
      />
      <ResponsiveListShell isOpen={isCareerSelectOpen} onClose={closeSelect}>
        <List.Root className="max-h-[460px] desktop:max-h-60">
          {CAREER.map((career) => (
            <List.Item
              key={career.key}
              text={career.value}
              selected={career.key === selectedCareer.key}
              onClick={() => {
                handleCareerChange(career);
                closeSelect();
              }}
            />
          ))}
        </List.Root>
      </ResponsiveListShell>
    </Box>
  );
};
export default PersonalizedAreaCareerSelect;
